import { render, staticRenderFns } from "./Ajoneuvotiedot.vue?vue&type=template&id=4548cc3e&scoped=true"
import script from "./Ajoneuvotiedot.vue?vue&type=script&lang=js"
export * from "./Ajoneuvotiedot.vue?vue&type=script&lang=js"
import style0 from "./Ajoneuvotiedot.vue?vue&type=style&index=0&id=4548cc3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4548cc3e",
  null
  
)

export default component.exports